module.exports = __webpack_public_path__ + "img/Norsk-billedbog-for-børn_Bilde-av-Kvensk-ABC.527f0e05.jpg";